import classNames from "classnames";
import React, { useRef, useEffect } from "react";

function SpecialtyCard({
  isEditable,
  value,
  handleInputChanges,
  item,
  handleIsEditableClick,
  handleClose,
  handleEditChange,
  handleDelete,
  placeholderLg,
  placeholderSm,
  errorMessage,
  isSpecialityEditing,
  newValue,
  isSpecialityAdd,
}) {
  const inputRef = useRef(null);
  const isValueEmpty = !value.trimStart();
  const isSame = value !== newValue;

  useEffect(() => {
    if (isEditable) {
      inputRef.current.focus();
    }
  }, [isEditable]);

  return (
    <div className="mt-2">
      <div className="clinic-timing-boxes d-flex justify-content-between view-depart">
        <div className="col-lg-11 d-flex" style={{ padding: "0" }}>
          {isEditable ? (
            <div className="input-wrapper wrapper-input  px-2 col-lg-11 ">
              <i className="ri-pencil-line edit-depart manage-icon me-5"></i>
              <input
                type="text"
                className=" form-control department border form-lg speciality-name"
                placeholder={placeholderLg}
                value={isSpecialityEditing || (isEditable && !isSpecialityAdd) ? newValue : value}
                onChange={handleInputChanges}
                ref={inputRef}
                maxLength={100}
              />
              <input
                type="text"
                placeholder={placeholderSm}
                className=" form-control department border form-sm"
                onChange={handleInputChanges}
                value={isSpecialityEditing ? newValue : value}
                maxLength={100}
                ref={inputRef}
              />
            </div>
          ) : (
            <>
              <i className="ri-empathize-line me-2 manage-icon icon-cursor"></i>
              <span className="speciality-name">{item.label}</span>
            </>
          )}
        </div>
        {/* <div className="col-lg-2" style={{padding: '0'}}>
                    {!isEditable ? (
                        <>
                            <i className={classNames(
                                isSpecialityEditing ? "ri-pencil-line manage-icon p-1 icon-hover-bg " : "ri-pencil-line manage-icon p-1 check-icon"
                            )} onClick={isSpecialityEditing ? handleIsEditableClick : null}></i>
                            <i className={isSpecialityEditing ? "ri-delete-bin-line manage-icon p-1 icon-hover-bg" : "ri-delete-bin-line manage-icon p-1  check-icon"} onClick={handleDelete}></i>
                        </>
                    ) : (
                        <>
                            <i className={classNames(
                                isValueEmpty || !isSame ? "ri-check-line manage-icon p-1 check-icon " : "ri-check-line manage-icon p-1 icon-hover-bg")} onClick={(isValueEmpty || !isSame) ? null : handleEditChange}
                                disabled={isValueEmpty}
                            ></i>
                            <i className="ri-close-fill manage-icon p-1 icon-hover-bg" onClick={handleClose}></i>
                        </>
                    )}
                </div> */}
      </div>
      <span className={classNames(errorMessage === "" ? "d-none " : "d-flex error-container")}>
        {errorMessage && errorMessage.length > 0 ? <i className="ri-information-line me-1" /> : null}
        {errorMessage}
      </span>
    </div>
  );
}

export default SpecialtyCard;
